<template>
  <div>
    <UCCodeScanner
      v-if="permitirFinPaleLecturaUltimaCaja"
      :text-button="$t('production.palletizing.readLatestPackage.btnText')"
      :allow-manual-code-entry="true"
      :auto-open-camera="true"
      fab-button-background-color="var(--his-dark-blue)"
      fab-button-min-width="250px"
      :continuous-bar-code-reading="configuracionLecturaCajas == null ? false : configuracionLecturaCajas.LecturaContinuaCodigosBarras"
      @code-reading="LecturaDeCodigoDeBarrasUltimaCaja"
      @codigo-barras="LecturaDeCodigoDeBarrasUltimaCaja"
    />
    <!-- Action Confirmación Finalizar Pale con lectura de cajas de distinta confección Partidas Activas -->
    <UCConfirmation ref="componenteConfirmacionrFinPaleDistintaConfeccion" />
  </div>
</template>

<script>
import { Log, LogError } from '@/js/common/HIDebuggingSupport';
import UCCodeScanner from '@/components/common/UCCodeScanner.vue';
import UCConfirmation from '@/components/common/UCConfirmation.vue';
import { TipoFinPaletPuntoPaletizado } from '@/js/services/traceability/enumeradosTA';
import ConexionTA from '@/js/services/traceability/APITraceability';
import {
  HiNotification,
  PreloaderGH,
} from '@/js/common/HINotificationSupport';
import { sleep } from '@/js/utils/sleep';

export default {
  name: 'PCFinPaleLecturaUltimaCaja',
  components: {
    UCCodeScanner,
    UCConfirmation,
  },
  props: {
    puntoPaletizadoSeleccionado: { type: Object, default: null },
    pedidoEnCurso: { type: Object, default: null },
    paleEnCursoSinPlanificar: { type: Object, default: null },
    configuracionLecturaCajas: { type: Object, default: null },
  },

  emits: ['PaleFinalizado'],

  data() {
    return {
      // actionConfirmarFinPaleDistintaConfeccion: false, // Controla la apertura y cierre del actión de confirmación.
      ultimoCodigoArticuloElaboradoLeido: '',
    };
  },
  computed: {
    puntoPaletizadoPermiteFinPaleConLecturaUltimaCaja() {
      if (this.puntoPaletizadoSeleccionado === null) {
        return false;
      }
      if (this.puntoPaletizadoSeleccionado.UtilizarUIC
        && (this.puntoPaletizadoSeleccionado.TipoFinPalet === TipoFinPaletPuntoPaletizado.ManualLecturaUltimoBulto
          || this.puntoPaletizadoSeleccionado.TipoFinPalet === TipoFinPaletPuntoPaletizado.ManualLecturaUltimoBultoReservado)) {
        return true;
      }
      return false;
    },
    permitirFinPaleLecturaUltimaCaja() {
      if (this.puntoPaletizadoPermiteFinPaleConLecturaUltimaCaja && (this.pedidoEnCurso != null || this.paleEnCursoSinPlanificar != null)) {
        return true;
      }
      return false;
    },
  },

  methods: {
    LecturaDeCodigoDeBarrasUltimaCaja(codigo) {
      Log(this, this.LecturaDeCodigoDeBarrasUltimaCaja.name);
      this.ultimoCodigoArticuloElaboradoLeido = codigo;
      const self = this;
      PreloaderGH(true, false, this.$t('production.palletizing.readLatestPackage.preloaderText'), '');
      this.Conexion_ObtenerArticuloElaborado(codigo).then((result) => {
        const objArticuloElaboradoLeido = result;
        if (objArticuloElaboradoLeido.NumeroSerie !== null) {
          PreloaderGH(false);
          HiNotification.Toast(self.$t('production.palletizing.readLatestPackage.articleAlreadyAssigned'));
          return;
        }
        if (self.pedidoEnCurso != null) {
          const producto = self.pedidoEnCurso.Producto.Composicion?.Componentes.find((c) => c.Componente.TipoArticulo === 'Producto')?.Componente || self.pedidoEnCurso.Producto;
          if (objArticuloElaboradoLeido.Producto.Id !== producto.Id
            || objArticuloElaboradoLeido.Envase.Id !== self.pedidoEnCurso.Envase.Id
            || objArticuloElaboradoLeido.Palet.Id !== self.pedidoEnCurso.Pale.Id) {
            PreloaderGH(false);
            this.$refs.componenteConfirmacionrFinPaleDistintaConfeccion.create(
              this.$t('production.palletizing.readLatestPackage.finishDifferentPalletMaking.title').toUpperCase(),
              this.$t('production.palletizing.readLatestPackage.finishDifferentPalletMaking.text'),
              () => {
                this.FinalizarPaleConLecturaUltimoBulto(this.ultimoCodigoArticuloElaboradoLeido);
              },
            );
            this.$refs.componenteConfirmacionrFinPaleDistintaConfeccion.show();
            return;
          }
        }
        if (self.paleEnCursoSinPlanificar != null) {
          if (objArticuloElaboradoLeido.Producto.Id !== self.paleEnCursoSinPlanificar.Articulo.Id
            || objArticuloElaboradoLeido.Envase.Id !== self.paleEnCursoSinPlanificar.Envase.Id
            || objArticuloElaboradoLeido.Palet.Id !== self.paleEnCursoSinPlanificar.Pale.Id) {
            PreloaderGH(false);
            this.$refs.componenteConfirmacionrFinPaleDistintaConfeccion.create(
              this.$t('production.palletizing.readLatestPackage.finishDifferentPalletMaking.title').toUpperCase(),
              this.$t('production.palletizing.readLatestPackage.finishDifferentPalletMaking.text'),
              () => {
                this.FinalizarPaleConLecturaUltimoBulto(this.ultimoCodigoArticuloElaboradoLeido);
              },
            );
            this.$refs.componenteConfirmacionrFinPaleDistintaConfeccion.show();
            return;
          }
        }
        PreloaderGH(false);
        sleep(100).then(() => {
          this.FinalizarPaleConLecturaUltimoBulto(codigo);
        });
      })
        .catch((menesaje) => {
          HiNotification.Toast(menesaje);
        }).finally(() => {
          PreloaderGH(false);
        });
    },

    FinalizarPaleConLecturaUltimoBulto(codigo) {
      Log(this, this.FinalizarPaleConLecturaUltimoBulto.name);
      const self = this;
      PreloaderGH(true, false, this.$t('production.palletizing.readLatestPackage.finish.preloaderText'), '');
      this.Conexion_FinalizarPaleConLecturaUltimoBulto(this.puntoPaletizadoSeleccionado.Id, codigo).then(() => {
        PreloaderGH(false);
        HiNotification.Toast(self.$t('production.palletizing.readLatestPackage.finish.successToastText'));
        this.$emit('PaleFinalizado');
      })
        .catch((menesaje) => {
          PreloaderGH(false);
          HiNotification.Toast(menesaje);
        }).finally(() => {
          PreloaderGH(false);
        });
    },

    Conexion_FinalizarPaleConLecturaUltimoBulto(idPuntoPaletizado, codigoBarrasArticuloElaborado) {
      Log(this, this.Conexion_FinalizarPaleConLecturaUltimoBulto.name);
      return new Promise((resolve, reject) => {
        ConexionTA.callFinalizarPaleConLecturaUltimoBulto(
          idPuntoPaletizado,
          codigoBarrasArticuloElaborado,
        ).then((result) => {
          if (result.Valor) {
            resolve(result.Mensaje);
          } else {
            reject(result.Mensaje);
          }
        })
          .catch((error) => {
            reject(error);
            LogError(error);
          });
      });
    },

    Conexion_ObtenerArticuloElaborado(codigoBarrasArticuloElaborado) {
      Log(this, this.Conexion_ObtenerArticuloElaborado.name);
      return new Promise((resolve, reject) => {
        ConexionTA.callObtenerArticuloElaboradoXCodigo(
          codigoBarrasArticuloElaborado,
        ).then((result) => {
          if (result.Valor) {
            resolve(JSON.parse(result.Mensaje));
          } else {
            reject(result.Mensaje);
          }
        })
          .catch((error) => {
            reject(error);
            LogError(error);
          });
      });
    },
  },
};
</script>
